import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
export default {
  name: "More",
  props: {
    value: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      visible: false,
      list: [{
        code: "0",
        name: $t("ep0os3", "待邀请"),
        check: false
      }, {
        code: "10",
        name: $t("fj1g2", "在职"),
        check: false
      }, {
        code: "50",
        name: $t("lb5z2", "禁用"),
        check: false
      }, {
        code: "99",
        name: $t("ler52", "离职"),
        check: false
      }]
    };
  },
  methods: {
    onChangeStatus(item) {
      item.check = !item.check;
      this.$emit("input", this.selectCheck());
      this.$emit("searchStatus");
    },
    selectCheck() {
      let arr = [];
      this.list.map(v => {
        if (v.check) {
          arr.push(v.code);
        }
      });
      return arr.join(",");
    }
  },
  mounted() {
    let arr = this.value.split(",");
    arr.map(v => {
      let index = this.list.findIndex(item => item.code === v);
      if (index > -1) {
        this.list[index].check = true;
      }
    });
  }
};